<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="entradas">
    <div class="row">
        <div class="col">
            <h5>Atualização de Informações de Risco</h5>
        </div>
    
        <div class="col-auto">
            <button type="button" class="btn btn-danger" 
                (click)="cancelar()">Cancelar
            </button>
            
            <button type="button" class="btn btn-primary" 
                (click)="enviar()" [disabled]="!modoEdicao" *ngIf="entradas.length > 0 && entradas.length <= limiteOperacoesCadastroViaTela">Enviar
            </button>
        </div>
    </div>

    <div class="row table-responsive tabela-atualizacao-info-risco" *ngIf="entradas.length > 0 && entradas.length <= limiteOperacoesCadastroViaTela">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col">Operação</th>
                    <th scope="col">Sistema</th>
                    <th scope="col">Risco/ Perda esperada 
                        <i class="fa fa-question-circle help-subtitulo" placement="top"
                             ngbTooltip="Avaliação de Risco ou Percentual de perda esperada do risco"></i>
                    </th>
                    <th scope="col">Liquidada</th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let entrada of entradas; let i = index">
                    <td class="bn-form-group">
                        <input type="text" name="idOperacaoAgenteCreditoLivre" class="form-control"
                            value="{{!!entrada?.idOperacaoAgenteCreditoLivre
                            ? entrada?.idOperacaoAgenteCreditoLivre 
                            : entrada?.contratoRepasse}}" disabled>
                    </td>
                    <td>
                        <select name="sistemaRepasse" id="sistemaRepasse" class="form-select" [(ngModel)]="entrada.sistemaRepasse" disabled>
                            <option [ngValue]="'15'">15 - Contratos FINAME</option>
                            <option [ngValue]="'89'">89 - Contratos BNDES</option>
                            <option [ngValue]="undefined">Crédito Livre</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" name="riscoOperacao" class="form-control" [(ngModel)]="entrada.riscoOperacao" [disabled]="!modoEdicao"
                            pattern="^[A-Za-z]{1,2}$|^[0-9]{1,3}(,[0-9]{0,2})?$" />	
                    </td>
                    <td><input type="checkbox" class="form-check checkbox-gigante" (click)="liquidada(i)"
                            [ngValue]="entrada.liquidada==='S'" [disabled]="!modoEdicao"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
    <table class="table-striped table-bordered">
        <thead>
        <tr>
            <th class="text-center" colspan="2">
            Erro(s) encontrado(s)
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let ocorrencia of ocorrencias">
            <td width="20%">
                {{ ocorrencia.idObjetoValidado }}
            </td>
            <td width="80%">
                {{ ocorrencia.mensagem }}
            </td>
        </tr>
        </tbody>
    </table>
    </div>
</div>

<div class="loading-pesquisa" *ngIf="!entradas">
    <i class="bn-loading"></i>
</div>

<div class="alert alert-info" *ngIf="entradas && entradas.length>limiteOperacoesCadastroViaTela">
    Cadastro via tela não é possível para {{entradas.length}} operações.
</div>

<div class="alert alert-info" *ngIf="entradas && entradas.length===0">
    Não há operações para atualização.
</div>